import { connect } from 'react-redux'
import { ThunkDispatch } from 'redux-thunk'
import { AnyAction } from 'redux'
import { isLoading } from 'flux-entities'

import { INewSSORealm } from '../../../../types/ssoRealm'
import { createSsoRealm } from '../../../../store/ssoRealms/actions'
import { Create } from './Create'
import { ICreateDispatchProps, ICreateStateProps } from './types'
import { IState } from '../../../../store/types'
import { fetchInstallations } from '../../../../store/installations/actions'

const mapStateToProps = (state: IState): ICreateStateProps => {
  return {
    installations: state.installations,
    ssoRealmsLoading: isLoading(state.ssoRealms)
  }
}

const mapDispatchToProps = (dispatch: ThunkDispatch<{}, {}, AnyAction>): ICreateDispatchProps => {
  return {
    fetchInstallations: () => {
      return dispatch(fetchInstallations())
    },
    createSsoRealm: (ssoRealm: INewSSORealm) => {
      return dispatch(createSsoRealm(ssoRealm))
    }
  }
}

const CreateContainer = connect(mapStateToProps, mapDispatchToProps)(Create)

export {
  CreateContainer
}
